import { render, staticRenderFns } from "./addmenu.vue?vue&type=template&id=886b6c4e&scoped=true"
import script from "./addmenu.vue?vue&type=script&lang=js"
export * from "./addmenu.vue?vue&type=script&lang=js"
import style0 from "./addmenu.vue?vue&type=style&index=0&id=886b6c4e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./addmenu.vue?vue&type=style&index=1&id=886b6c4e&prod&lang=css"
import style2 from "./addmenu.vue?vue&type=style&index=2&id=886b6c4e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style3 from "./addmenu.vue?vue&type=style&index=3&id=886b6c4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886b6c4e",
  null
  
)

export default component.exports